import { Can } from 'components/Can';
import MidtermReviewFormEdit from 'features/MidtermReview/pages/Edit';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

export default function MidtermReviewFormEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <Can do="update" on="midterm_review">
          <MidtermReviewFormEdit />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}
